import React, { useState } from 'react';
import PurchaseListTemplate from '../../../pages/purchase/components/PurchaseListTemplate';
import { PurchaseTabScene, PurchaseInfo, PurchaseStatus } from '../../../types/process/purchase';
import { useDefaultQueryFields } from '../../../pages/purchase/purchase.effect';
import PurchaseTriggerActionMap, { PurchaseTriggerActionProvider, PurchaseTriggerTarget, usePurchaseActionContext } from '../../../pages/purchase/components/PurchaseTriggerActionMap';
import { Button } from 'antd';

const BatchDeclareButton: React.FC<{ selectedRows: PurchaseInfo[] }> = ({ selectedRows }) => {
  const context = usePurchaseActionContext();
  return (
    <Button
      type="primary"
      disabled={selectedRows.length === 0}
      onClick={() => {
        context.openBatchDeclareModal?.({ selectedRows });
      }}
    >
      批量申报
    </Button>
  );
};

const PurchaseUndeclaredList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey(k => k + 1);
  const queryFields = useDefaultQueryFields(PurchaseTabScene.Undeclared);

  const renderTableActions = (order: PurchaseInfo) => {
    const targets: PurchaseTriggerTarget[] = [];
    if (order.purchase.status === PurchaseStatus.Undeclared) {
      targets.push('declare');
    }
    return <PurchaseTriggerActionMap targets={targets} purchase={order} onReload={reloadList} />;
  };

  return (
    <PurchaseTriggerActionProvider onReload={reloadList}>
      <PurchaseListTemplate
        title="待申报列表"
        refreshKey={refreshKey}
        queryFields={queryFields}

        tabScene={PurchaseTabScene.Undeclared}
        defaultScene={PurchaseTabScene.Undeclared}
        viewModes={React.useMemo(() => [
          {
            mode: 'table' as const,
            label: '表格页',
            renderActions: renderTableActions,
            showField: 'tab_undeclared',
            renderBatchActions: (selectedRows: PurchaseInfo[], clearSelection: () => void, activeTabKey?: string) => {
              // 只在全部(一般为空/未定义或 tab_undeclared) 或 已完善信息(tab_undeclared_info_completed) 的 tab 下显示批量操作。
              const isAllowedTab = !activeTabKey || activeTabKey === 'tab_undeclared' || activeTabKey === 'tab_undeclared_info_completed';

              if (!isAllowedTab) return null;

              return <BatchDeclareButton selectedRows={selectedRows} />;
            }
          }
        ], [renderTableActions])}
      />
    </PurchaseTriggerActionProvider>
  );
};

export default PurchaseUndeclaredList;
